import RoomtypeForm from '../screens/RoomtypeForm'
import RoomtypeTabs from '../screens/RoomtypeTabs'
import RoomtypesList from '../screens/RoomtypesList'
import { allRoles, ROLE, RouteWithAccessType } from './types'

const roomTypePagesRoleManagement: RouteWithAccessType[] = [
  {
    route: '/accommodations/:accommodationID/:propertyCode/room-types/list',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.TENANT_MARKETING,
      ROLE.PROVIDER_MARKETING,
      ROLE.TENANT_IT,
      ROLE.PROVIDER_IT,
      ROLE.TENANT_MANAGEMENT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.TENANT_PR,
      ROLE.CHANNEL_ACTIVATION
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.ACCOMMODATION,
      ROLE.TENANT_MARKETING,
      ROLE.CHANNEL_ACTIVATION
    ],
    requiredFeatures: ['roomtype.list.view'],
    component: <RoomtypesList />
  },
  {
    route:
      '/accommodations/:accommodationID/:propertyCode/room-types/:roomTypeId/:roomTypeCode/:page',
    exact: true,
    rolesListWithReadAccess: allRoles,
    rolesListWithWriteAccess: allRoles,
    requiredFeatures: ['roomtype.list.view'],
    component: <RoomtypeTabs />,
    tabs: [
      {
        params: { page: 'details' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_FINANCE,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.ACCOMMODATION,
          ROLE.ACCOMMODATION_OPERATOR,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.TENANT_IT,
          ROLE.TENANT_MANAGEMENT,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.TENANT,
          ROLE.CHANNEL_ACTIVATION
        ],
        requiredFeatures: ['roomtype.details.view']
      },
      {
        params: { page: 'images' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_FINANCE,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.ACCOMMODATION,
          ROLE.ACCOMMODATION_OPERATOR,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.TENANT_IT,
          ROLE.TENANT_MANAGEMENT,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.TENANT,
          ROLE.CHANNEL_ACTIVATION
        ],
        requiredFeatures: ['roomtype.images.manage']
      },
      {
        params: { page: 'facilities' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_FINANCE,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.ACCOMMODATION,
          ROLE.ACCOMMODATION_OPERATOR,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.TENANT_IT,
          ROLE.TENANT_MANAGEMENT,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.TENANT,
          ROLE.CHANNEL_ACTIVATION
        ],
        requiredFeatures: ['roomtype.facilities.manage']
      }
    ]
  },
  {
    route: '/accommodations/:accommodationID/:propertyCode/room-types/create',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN, ROLE.CHANNEL_ACTIVATION],
    rolesListWithWriteAccess: [ROLE.ADMIN, ROLE.CHANNEL_ACTIVATION],
    requiredFeatures: ['roomtype.create'],
    component: <RoomtypeForm />
  }
]

export default roomTypePagesRoleManagement
